import { DarkReadManager } from "@faire/deprecated-retailer-visitor-shared/initialize/dark-read/DarkReadManager";
import { RequestOptions } from "@faire/web-api--source/types";
import { HEADER_LOCALE_OVERRIDE } from "@faire/web/common/consts/HEADER_LOCALE_OVERRIDE";
import { getRandomLocale } from "@faire/web/common/dark-reads/getRandomLocale";

export const getOverrideLocaleHeader = (
  darkReadRequestOptions: RequestOptions
) => {
  const headers = new Headers(darkReadRequestOptions.headers);
  const shouldOverrideLocale =
    DarkReadManager.localeOverride().canPerformDarkReads;
  if (shouldOverrideLocale) {
    headers.set(HEADER_LOCALE_OVERRIDE, getRandomLocale());
  }

  return headers;
};
